module.exports = __webpack_public_path__ + "img/45_8.015c8f8b.png";